import types from '../types.js';
import { setState } from '../../utils/redux';
import { getStoredPortalPreview } from '../../utils/portalPreview';

const storedPreviewPortal = getStoredPortalPreview();

const initialState = {
  portals: null,
  selectedPortal: storedPreviewPortal,
  previewPortalId: storedPreviewPortal?.id || null
};

const portalReducer = (state = initialState, action) => {
  const { LOAD_PORTALS, SELECT_PORTAL, START_PORTAL_PREVIEW, STOP_PORTAL_PREVIEW } = types;

  switch (action.type) {
    case LOAD_PORTALS:
      return setState(state, 'portals', action.payload);
    case SELECT_PORTAL:
      if (state.previewPortalId && action.payload?.id !== state.previewPortalId) return state;
      return setState(state, 'selectedPortal', action.payload);
    case START_PORTAL_PREVIEW:
      return {
        ...state,
        selectedPortal: action.payload,
        previewPortalId: action.payload.id
      };
    case STOP_PORTAL_PREVIEW:
      return {
        ...state,
        selectedPortal: null,
        previewPortalId: null
      };
    default:
      return state;
  }
};

export default portalReducer;
